import { PEC2852, PEC2853, PEC2854, PEC2855, PEC2856, PEC2857, PEC2858, PEC2859, PEC2860, PEC2861, PEC2862, } from '@purepm/purepm-lovs';
import { ENTITY_ERROR_MESSAGES } from './entityErrorMessages.constants';
export const errorMessageOnAddPaymentMethodMap = {
    default: 'An unexpected error occurred while adding payment method.',
    [ENTITY_ERROR_MESSAGES.PERSON.NO_PHONE]: 'Unable to add payment method: Missing phone number. Contact your property manager to update this information.',
    [ENTITY_ERROR_MESSAGES.PERSON.NO_ADDRESS]: 'Unable to add payment method: Missing address. Contact your property manager to update this information.',
    [ENTITY_ERROR_MESSAGES.PERSON.NO_PHONE_AND_ADDRESS]: 'Unable to add payment method: Missing address and phone number. Contact your property manager to update this information.',
    [ENTITY_ERROR_MESSAGES.PERSON.NO_EMAIL]: 'Unable to add payment method: Missing email address. Contact your property manager to update this information.',
};
export const PEC_ERROR_MAP = {
    [PEC2852.code]: PEC2852,
    [PEC2853.code]: PEC2853,
    [PEC2854.code]: PEC2854,
    [PEC2855.code]: PEC2855,
    [PEC2856.code]: PEC2856,
    [PEC2857.code]: PEC2857,
    [PEC2858.code]: PEC2858,
    [PEC2859.code]: PEC2859,
    [PEC2860.code]: PEC2860,
    [PEC2861.code]: PEC2861,
    [PEC2862.code]: PEC2862,
};
